import styled from 'styled-components';

export const PPTSummaryMapContainer = styled.div`
  overflow: hidden;
  transition: height 0.3s;
  width: calc(100% + 20px);
  transform: translateX(-20px);
  .PPTSummaryMapContainer_content {
    padding-left: 20px;
  }
`;
